import React from 'react';
import { useSelector } from 'react-redux';
import { getFirstName, getLastName, getMemberId, getPointsBalance, getMembershipTier } from 'store/user/userSelectors';
import { Icon, Flex } from 'roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import FormatNumber from 'components/formatters/FormatNumber';

const UserInfoCard = styled(Flex)`
  flex-direction: column;
  background-color: ${themeGet('colors.brand.primary')};
  color: ${themeGet('colors.white')};
  align-items: center;
  font-size: ${themeGet('fontSizes.base')};
  padding: ${themeGet('space.5')} ${themeGet('space.2')};
`;

const Circle = styled(Flex)`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px white solid;
  align-items: center;
  justify-content: center;
`;

const QffPersonalInfo = () => {
  const firstName = useSelector(getFirstName);
  const lastName = useSelector(getLastName);
  const memberId = useSelector(getMemberId);
  const pointsBalance = useSelector(getPointsBalance);
  const membershipTier = useSelector(getMembershipTier);

  return (
    <UserInfoCard>
      <Flex mb={2}>
        <Circle>
          <Icon name="person" size={16} pb="2px" />
        </Circle>
      </Flex>
      <Flex flexWrap="wrap" textAlign="center" data-testid="full-name-member-id">
        {firstName} {lastName} ({memberId})
      </Flex>
      <Flex data-testid="points-balance">
        <FormatNumber number={pointsBalance} /> points
      </Flex>
      <Flex data-testid="membership-tier">{membershipTier}</Flex>
    </UserInfoCard>
  );
};

export default QffPersonalInfo;
